"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModalContentHeader = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var core_1 = require("@material-ui/core");
var ModalContentHeader_styles_1 = require("./ModalContentHeader.styles");
var ModalContentHeader = function (_a) {
    var children = _a.children, centered = _a.centered, _b = _a.dataName, dataName = _b === void 0 ? 'element' : _b;
    var classes = (0, ModalContentHeader_styles_1.useModalContentHeaderStyles)();
    return (react_1.default.createElement("div", { className: classes.main, "data-signa": "modal-content-header-".concat(dataName) },
        react_1.default.createElement("div", { className: "".concat(centered ? classes.centered : '') },
            react_1.default.createElement(core_1.Typography, { className: classes.title, variant: "h4" }, children))));
};
exports.ModalContentHeader = ModalContentHeader;
